// extracted by mini-css-extract-plugin
export default {"button":"ButtonTempleView_button__8rvG1","inactive":"ButtonTempleView_inactive__4Jy9+"};